module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /usr/local/lib/~/cooking-cli/~/stream-browserify/~/readable-stream/passthrough.js
// module id = 486
// module chunks = 1